import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SkeletonCardTableComponent } from '@okcargo-apps/layout-ionic';
import { IFreightBasicForShipper } from '@okcargo-apps/shared-domain';
import { Observable } from 'rxjs';
import { FreightShipperCardComponent } from '../freight-shipper-card/freight-shipper-card.component';
import { FreightShipperService } from '../freight-shipper.service';

@Component({
  selector: 'lib-freight-shipper-finished-list',
  templateUrl: './freight-shipper-finished-list.component.html',
  styleUrls: ['./freight-shipper-finished-list.component.scss'],
  imports: [CommonModule, SkeletonCardTableComponent, TranslateModule, FreightShipperCardComponent],
})
export class FreightShipperFinishedListComponent {
  private readonly freightShipService = inject(FreightShipperService);

  public freights$: Observable<IFreightBasicForShipper[]>;

  constructor() {
    this.freights$ = this.freightShipService.freightsShipFinished$;
  }

  get loading(): boolean {
    return this.freightShipService.freightsShipFinishedLoading();
  }
}
